import { loadStripe, Stripe } from "@stripe/stripe-js";

export const config = {
    region: import.meta.env.VITE_REGION,
    auth: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID,
        clientId: import.meta.env.VITE_CLIENT_ID,
    },
    api: {
        endpointUrl: import.meta.env.VITE_API_ENDPOINT_URL,
        key: import.meta.env.VITE_API_KEY,
    },
    restApi: {
        baseUrl: import.meta.env.VITE_RESTAPI_BASE_URL,
    },
    stripe: {
        publicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
    },
    highlightIoProjectID: import.meta.env.VITE_HIGHLIGHT_IO_PROJECT_ID,
};

let stripePromise: Promise<Stripe>;
export const getStripe = () => {
    if (stripePromise) {
        return stripePromise;
    }

    stripePromise = loadStripe(config.stripe.publicKey);
    return stripePromise;
};
